<mat-radio-group *ngIf="radioData?.length">
    <mat-radio-button *ngFor="let data of radioData; index as i" class="button{{i+1}}" value="{{data.name}}"
        color="primary">
        <div class="Card">
            <small class="recommend" *ngIf="data.recommended"> Recommendation</small>
            <h5>{{data.name}}</h5>
            <span class="subname" *ngIf="data.subname">
                {{data.subname}}
            </span>
            <span class="price" *ngIf="data.price">
                {{data.price}} <small *ngIf="data.price!='$0'">/container</small>
            </span>
            <span class="pay" *ngIf="data.pay">
                {{data.pay}}
            </span>
            <span class="details" *ngIf="data.details">{{data.details}}</span>
            <div></div>
        </div>
    </mat-radio-button>
</mat-radio-group>

<ng-container *ngIf="options?.length">
    <mat-radio-group [ngModel]="item" (ngModelChange)="pushData($event)">
        <mat-radio-button *ngFor="let option of options; index as i" class="button{{i+1}}" [value]="option"
            color="primary">
            <div class="Card">
                <small class="recommend" *ngIf="option.is_recommended">Recommended</small>
                <h5>{{option.name}}</h5>
                <span class="details" *ngIf="option.description">{{option.description}}</span>
                <div></div>
            </div>
        </mat-radio-button>
    </mat-radio-group>
</ng-container>

<ng-container *ngIf="insList?.length">
    <mat-radio-group [ngModel]="data" (ngModelChange)="pushInsuranceData($event)" [name]="name" [disabled]="disabled">
        <mat-radio-button *ngFor="let insurance of insList; index as i" class="button{{i+1}}" [value]="insurance"
            color="primary">
            <div class="Card">
                <!-- <small class="recommend" *ngIf="insurance.recommended"> Recommendation</small> -->
                <h5>{{insurance?.name}}</h5>
                <span class="subname" *ngIf="insurance.short_description">
                    {{insurance?.short_description}}
                </span>
                <span class="price" *ngIf="insurance?.amount">
                    {{insurance?.amount}} {{insurance?.amount_currency}}<small
                        *ngIf="insurance.amount!=0">/{{insurance?.amount_unit?.value}}</small>
                </span>
                <!-- <span class="pay" *ngIf="insurance.pay">
                {{insurance.pay}}
            </span>
            <span class="details" *ngIf="insurance.details">{{insurance.details}}</span>
            <div></div> -->
            </div>
        </mat-radio-button>
    </mat-radio-group>
</ng-container>

<ul *ngIf="errors?.length" class="errorList">
    <li *ngFor="let item of errors" class="error">{{item}}</li>
</ul>